import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import SucursalLogo from './SucursalLogo';

const TIPOS = ['image/jpeg', 'image/png', 'image/webp'];
const MAX_BYTES = 5 * 1024 * 1024;

// Firma real del archivo (no la extensión): JPEG FF D8 FF · PNG 89 50 4E 47 · WEBP RIFF…WEBP.
async function firmaValida(file) {
  const b = new Uint8Array(await file.slice(0, 16).arrayBuffer());
  const ascii = (i, j) => String.fromCharCode(...b.slice(i, j));
  if (b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff) return true;
  if (b[0] === 0x89 && ascii(1, 4) === 'PNG') return true;
  return ascii(0, 4) === 'RIFF' && ascii(8, 12) === 'WEBP';
}
// Que el navegador pueda realmente decodificarla como imagen.
const decodifica = (url) => new Promise((ok) => { const img = new Image(); img.onload = () => ok(img.naturalWidth > 0); img.onerror = () => ok(false); img.src = url; });

/**
 * Logo de la sucursal: vista previa inmediata, subir/cambiar/quitar.
 * value: { url, file } — `file` es la imagen nueva aún no subida (se sube al guardar).
 */
export default function LogoUploader({ nombre, value, onChange }) {
  const inputRef = useRef(null);
  const [preview, setPreview] = useState(null);

  // Vista previa local del archivo elegido (sin subirlo todavía).
  useEffect(() => {
    if (!value.file) { setPreview(null); return undefined; }
    const url = URL.createObjectURL(value.file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [value.file]);

  const elegir = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = ''; // permite volver a elegir el mismo archivo
    if (!file) return;
    if (!TIPOS.includes(file.type)) return Swal.fire('Logo', 'Formato no permitido. Usa JPG, PNG o WEBP.', 'warning');
    if (file.size > MAX_BYTES) return Swal.fire('Logo', 'La imagen supera 5 MB.', 'warning');
    const tmp = URL.createObjectURL(file);
    const ok = (await firmaValida(file)) && (await decodifica(tmp));
    URL.revokeObjectURL(tmp);
    if (!ok) return Swal.fire('Logo', 'El archivo no es una imagen válida.', 'warning');
    onChange({ url: value.url, file });
  };

  const actual = preview || value.url || null;
  return (
    <div className="logo-uploader">
      <SucursalLogo sucursal={{ nombre, logoUrl: actual }} size={110} />
      <div className="logo-uploader-acciones">
        <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" hidden onChange={elegir} />
        <div className="logo-uploader-botones">
          <button type="button" className="btn btn-primary" onClick={() => inputRef.current?.click()}>{actual ? 'Cambiar imagen' : 'Subir imagen'}</button>
          {actual && <button type="button" className="btn" onClick={() => onChange({ url: '', file: null })}>Quitar imagen</button>}
        </div>
        <small className="form-hint">JPG, PNG o WEBP. Máximo 5 MB.{value.file ? ` Nueva imagen: ${value.file.name} (se guarda al confirmar).` : ''}</small>
      </div>
    </div>
  );
}
